module.exports = __webpack_public_path__ + "static/media/Purificador.88ee2804.pdf";